import React from 'react';
//import './TwoColumn.css'
//import './TwoColumn.css'
import './Column.css'
// import './Card.css'

export default function TwoColumn({ children, ...attributes }) {
  return (
    <div 
        className='twoCol'
        {...attributes}
    >
        
        {children}
            
        </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/TwoColumn.jsx